import styles from '../../css/Report.module.css';

export default function ToggleBtn({
	state,
	setState,
	setIsExpanded,
}) {
	const toggleEvent = () => {
		setState({ ...state, toggle: !state.toggle, menu:false, toggleGu:false, range: false})
		setIsExpanded(!state.toggle)
	}

	return (
		<span className={styles.toggleBtn} onClick={toggleEvent}>
			<img src={`${state.toggle ? 'img/icon_arrow_right.png' : 'img/icon_arrow_left.png'}`} alt='arrow' />
		</span>
	)
}